import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { getMessage, changeLanguage } from "CONFIG/i18n";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isIE } from "react-device-detect";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import UserInviteCustomize from "COMPONENTS/SessionManagement/UserInviteCustomize/UserInviteCustomize";
import Spinner from "COMPONENTS/Spinner/Spinner";
import { separatePhoneNumberAndEmails, getPhoneNumberWithCountryCode, setSMSMessage, checkInvite} from "UTILS/Utility";
import validator from "validator";
import { validateMobileNumber } from "UTILS/regexValidations";
import { USER_ROLES } from "UTILS/Constants";

import { debounceTime } from "rxjs/operators";

//ASSETS
import icBar from "ASSETS/Images/ic_bar.svg";
import icBack from "ASSETS/Images/back.svg";
import icMeeting from "ASSETS/Images/menu_icons/icon_meeting.svg";

//Stylesheet
import "./startSession.less";

import * as rxjs from "rxjs";

import {
  Row,
  Col,
  InputGroup,
  FormControl,
  Modal
} from "react-bootstrap";

//ASSETS
import ic_success_modal from "ASSETS/Images/ic_session_scheduled_popup.svg";

//Utility
import { isElementInViewport, getAnnouncementMarquee } from "UTILS/Utility";
import { ERROR, SESSION_TYPE, MODAL_TYPE, MEETING_JOIN_TYPE } from "UTILS/Constants";

import smoothscroll from 'smoothscroll-polyfill';

//Utilities
import { checkEmpty } from "UTILS/Utility";

//Actions
import { startSessionAction as actionFactory, organisationAction } from "CONFIG/ActionFactory";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";

import { getCurrentSessionInvitees } from "COMPONENTS/Sessions/selectors";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

// Selector
import { selectIsSMSEnabled } from "REDUX/Selector/OrganisationSelector";

class StartSession extends Component {
  constructor(props) {
    super(props);
    this.getInvitees = new rxjs.Subject();
    this.sessionProceed = new rxjs.Subject();
    this.state = {
      sessionKey: "",
      sessionTitle: "",
      pastSessionErrorMessage:"",
      errorMessage: "",
      errorCode: "",
      inviteeErrorMessage: "",
      inviteeErrorCode: "",
      inviteeInvalid: false,
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteeErrorMessage: "",
      checkInviteMessage: "",
      checkInviteList: [],
      selectedEmail: "",
      selectedPhone: "",
      inviteesList: [],
      currentSessionInvitees: this.props.currentSessionInvitees,
      invitees: "",
      scheduleDate : "",
      scheduleDateError : "",
      timeError : "",
      sessionType: this.props.sessionType,
      showModal: false,
      modalMessage: "",
      modalType: "",
      modalIcon: ic_success_modal,
      closeRecentEmail: true,
      closeRecentPhone: false,
      joinType: this.props.isPasscodeEnabled ? 
        MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE : 
        MEETING_JOIN_TYPE.SET_UP_NEW_MEETING,
      maxSmsSendMessageError: "",
      isUserInventMsgCustomizeEnable: this.props.userInventMsgCustomize ? this.props.userInventMsgCustomize.isEnable || false : false,
      userInventMsgCustomizeInfo: null,
    };
    changeLanguage();
  }
  
  handleInputChange = event => {
    this.setState({
      sessionTitle: event.target.value,
      errorMessage:"",
      pastSessionErrorMessage:""
    });
  };

  handleInviteeInputChange = () => event => {
    this.setState({
      invitees : event.target.value.replace(" ", "").trim(),
      inviteeInvalid: false,
      inviteeErrorMessage: "",
      inviteeErrorCode: "",
      isCheckInvite: false,
      isInviteForce: false,
      checkInviteeErrorMessage: "",
      checkInviteMessage: "",
      checkInviteList: [],
    });
  };

  componentDidMount() {
    smoothscroll.polyfill();

    //fetch passcode when get network online
    window.addEventListener("online", this.getPasscodeWhenNetworkReconnected);

    //fetch passcode when get on start meeting tab 
    navigator.onLine && this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE &&
      this.getPasscode();
   
    this.sessionProceed.pipe(debounceTime(500)).subscribe(fn => {
      if (typeof fn === "function") fn();
    });
    
    window.addEventListener('online', this.updateErrorMessageWhenNetworkReconnected);

    setSMSMessage(this, ["PLEASE_CHOOSE_ANY_GUIDANCE_METHOD_NON_SMS", "SET_UP_NEW_MEETING_NON_SMS"]);

    if (this.props.role != USER_ROLES.USER) {
      organisationAction.getCustomerSmsSendNum().then(
        response => {
          const maxSmsSend = response.data.data.maxSmsSend;
          const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
          const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;

          if (this.props.isSMSEnabled && maxSmsSend != 0 && (smsSendToday + smsSendThisMonth >= maxSmsSend)) {
            this.setState({maxSmsSendMessageError: "ERR_MSG_MAX_SMS_SEND" });
          }
        }
      )
    }
  }

  getPasscodeWhenNetworkReconnected = () => {
    if(this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE) {
      this.getPasscode();
    }
  }

  updateErrorMessageWhenNetworkReconnected = () => {
    let errorMessage = this.state.errorMessage == ERROR.NETWORK_ERROR ? "" : this.state.errorMessage
    this.setState({
      pastSessionErrorMessage: "", 
      errorMessage: errorMessage
    })
  }
  
  passcodeSuccessCallback = (response) => {
    this.showHideSpinner(false);
    this.isPasscodeAvailable();
  }
 
  passcodeErrorCallback = (errorCode) => {
    this.showHideSpinner(false);
    if(errorCode !== ERROR.NOT_AUTHORIZED && errorCode !== ERROR.USER_DELETED) {
      toastr.error(getMessage(errorCode))
    }
    this.isPasscodeAvailable();
  }
 
  isPasscodeAvailable = () => {
    //check if passcode is not available disable the proceed button
    if(this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE
      && !document.getElementById("generatedPasscode")?.value) {
      this.enableDisableProceedBtn(true);
    }
  }

  getPasscode =()=> {
    let uriIdentifier = this.props.uriIdentifier !== "/"
      ? this.props.uriIdentifier
      : ""
    if(window.getPasscode) {
      this.showHideSpinner(true);
      window.getPasscode(
        this.props.role, 
        window.location.origin+uriIdentifier+"/joinWithPasscode", 
        window._env_.REACT_APP_LOOOKIT_SERVICES_BASE_URL, 
        this.props.userToken,
        document.getElementById("lookitPasscode"),
        undefined,
        this.passcodeSuccessCallback,
        this.passcodeErrorCallback);
    } else {
      //TODO: change the error message to asking user for refresh the page
      console.error('Passcode Error: window.getPasscode not found..');
      toastr.error(getMessage("INTERNAL_SERVER_ERROR"));
    }
  }

  onInviteesChange = e => {
    this.getInvitees.next(e.target.value);
  };

  resetPastSessionError = () => {
    this.setState({pastSessionErrorMessage: ""})
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentSessionInvitees !== this.props.currentSessionInvitees) {
      this.setState({
        currentSessionInvitees: this.props.currentSessionInvitees
      });
    }
    if(prevProps.isPasscodeEnabled != this.props.isPasscodeEnabled) {
      if(this.props.isPasscodeEnabled) {
        this.setState({
          joinType: MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE
        },()=> this.getPasscode())
      } else {
        this.setState({
          joinType: MEETING_JOIN_TYPE.SET_UP_NEW_MEETING
        })
      }
    }
  }

  componentWillUnmount() {
    console.log("componentWillUnmount StartSession");
    window.removeEventListener('online', this.getPasscodeWhenNetworkReconnected);
    window.removeEventListener('online', this.updateErrorMessageWhenNetworkReconnected);
  }

  isInputValid = async() => {
    let passcode = document.getElementById("generatedPasscode") ?
      document.getElementById("generatedPasscode").value :
      undefined;

    // setup meeting validation check
    if (this.state.joinType === MEETING_JOIN_TYPE.SET_UP_NEW_MEETING &&
      checkEmpty(this.state.sessionTitle.trim())) {
      this.setState({
        errorMessage: "ERR_MSG_SESSION_TITLE"
      });
      window.scrollTo(0, 0);
      return false;
    }

    // passcode validation check 
    if (!navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return false;
    }

    return await this.validateAndGetInvitees();
  }

  validateAndGetInvitees = async() => {
    if(this.state.invitees && this.state.invitees.trim().length > 0 
    && this.state.joinType === MEETING_JOIN_TYPE.SET_UP_NEW_MEETING) {
      var separators = [",", ";"];
      let arrayOfInvitees = this.state.invitees.split(
        new RegExp(separators.join("|"), "g")
      );
      let allInvites = this.state.sessionType === SESSION_TYPE.UPDATE_SCHEDULE_MEETING ? [] :
        [...this.state.currentSessionInvitees];
      let{ arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);

      // validate emails - starts
      for (var i = 0; i < arrayOfEmails.length; i++) {
        let email = arrayOfEmails[i];
        let isValidEmail = validator.isEmail(email);
        if(!isValidEmail) {
          this.setState({
            inviteeInvalid: true,
            inviteeErrorMessage: getMessage("VALID_EMAIL"),
            inviteeErrorCode: "VALID_EMAIL"
          });
          this.showHideSpinner(false);
          return false;
        }
        allInvites.push({email});
      }   // validate emails - ends

      if (! this.props.isSMSEnabled && arrayOfPhone.length!=0) {
        this.setState({
          inviteeInvalid: true,
          inviteeErrorMessage: getMessage("ERR_MSG_UNABLE_SMS"),
          inviteeErrorCode: "ERR_MSG_UNABLE_SMS"
        });
        return false;
      }

      // validate phone no - starts
      for (var i = 0; i < arrayOfPhone.length; i++) {
        if (arrayOfPhone[i]) {
          let isValidPhone = validateMobileNumber(arrayOfPhone[i]);
          if(!isValidPhone) {
            this.setState({
              inviteeInvalid: true,
              inviteeErrorMessage: getMessage("VALID_PHONE"),
              inviteeErrorCode: "VALID_PHONE"
            });
            this.showHideSpinner(false);
            return false;
          }
          allInvites.push({
            phone: getPhoneNumberWithCountryCode(arrayOfPhone[i]).trim()
          });
        }
      }

      if (!this.state.isInviteForce) {
        const resultCheckInvite = await checkInvite([...allInvites]);
        if (resultCheckInvite) {
          this.setState({
            isCheckInvite: true,
            checkInviteeErrorMessage: getMessage("INVITATION_CHECK_ERROR"),
            checkInviteList: resultCheckInvite
          });
          this.showHideSpinner(false);
          return false;
        }
      }

      // validate phone no - ends
      this.setState({
        currentSessionInvitees: [...allInvites],
        selectedEmail: "",
        selectedPhone: "",
      });
    }
    return true;
  }

  handleProceedSMS = () => {
    if (this.props.isSMSEnabled) {

      var separators = [",", ";"];
      let arrayOfInvitees = this.state.invitees.split(
        new RegExp(separators.join("|"), "g")
      );
      let{ arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfInvitees);
      
      this.setState({maxSmsSendMessageError: ""})
      new Promise((resolve, reject) =>{
        organisationAction.getCustomerSmsSendNum().then(
          response => {
            const maxSmsSend = response.data.data.maxSmsSend;
            const smsSendToday = response.data.data.smsSendInfo[0].sms_count;
            const smsSendThisMonth = response.data.data.smsSendInfo[1].sms_count;

            if (arrayOfPhone.length!=0 && arrayOfPhone[0] != '') {
              if (this.props.isSMSEnabled && maxSmsSend != 0 && (arrayOfPhone.length + smsSendToday + smsSendThisMonth > maxSmsSend)) {
                this.setState({maxSmsSendMessageError: "ERR_MSG_MAX_SMS_SEND" });
                let proceedBtn = document.getElementById("proceedBtn");
                proceedBtn.disabled = false;
              } else {
                this.handleProceed();
              }
            } else {
              this.handleProceed();
            }
          }
        )
      })
    } else {
      this.handleProceed();
    }
  }

  // start instant meeting
  handleProceed = () => {
    this.isInputValid().then((result) => {
      if (result) {
        this.setState({
          pastSessionErrorMessage: "",
          errorMessage: "",
          errorCode: ""
        })

        let passcode = document.getElementById("generatedPasscode")?.value;

        let sessionDetails = {
          passcode
        }

        //join_with_passcode
        this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE ?
          sessionDetails.sessionTitle = passcode
          : //setup_new_meeting
          sessionDetails.sessionTitle = this.state.sessionTitle.trim();

        this.showHideSpinner(true);
        this.props.startSession(this.state.currentSessionInvitees, sessionDetails, this.instantSessionErrorHandler, undefined, this.state.userInventMsgCustomizeInfo);

      } else {
        let proceedBtn = document.getElementById("proceedBtn");
        proceedBtn.disabled = false;
      }
    });
  };

  instantSessionErrorHandler = (pastSessionErrorMsg) => {
    this.setState({
      pastSessionErrorMessage: pastSessionErrorMsg
    })
    this.showHideSpinner(false);
  }

  showHideSpinner = showSpinner => {
    this.setState({
      spinnerVisibility: showSpinner
    })
  }

  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      if(this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE){
        this.handleProceed();
      } else {
        this.handleProceedSMS();
      }
    }
  };

  toggleModal = () => {
    this.setState({
      showModal : !this.state.showModal,
      modalType: "", 
      modalMessage: "",
      modalIcon: "",
    })
  }

  testEmail = () => {
    return this.state.selectedEmail.includes(',') ? this.state.selectedEmail : "";
  }

  testNumber = () => {
    let isCommaPresent = this.state.selectedPhone.includes(',');
    if(isCommaPresent) {
      return this.state.selectedPhone;
    }
    return "";
  }

  backYesHandle = () =>{
    this.props.backToMenu();
  }

  changeJoinType = (joinType) =>{
    this.setState({
      joinType,
      errorMessage: "",
      inviteeErrorCode: ""
    }, () => {
      //fetch passcode when switch from setup meeting to passcode tab
      if(joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE && navigator.onLine){
        this.getPasscode();
      }
    });
    
  }

  renderInviteeSection = () => {
    return (
      <div>
        <input
          type="text"
          className="formControlName border w-100 form-control"
          onChange={this.handleInviteeInputChange()}
          value={this.state.invitees}
          placeholder= {getMessage("INVITE_INPUT_PLACEHOLDER")}
          style={{width: "100%"}}
        />
        {(!this.state.isCheckInvite) ?
          <Row className="d-flex justify-content-center errors my-0 py-2">
            {this.state.inviteeErrorCode === "PROPS"
              ? this.state.inviteeErrorMessage
              : getMessage(this.state.inviteeErrorCode)}
          </Row>:
          <>
            <Col className="errors text-center error-message">
              {this.state.checkInviteeErrorMessage}
            </Col>
            <Col className="errors text-center error-message">
              {this.showCheckInvite()}
            </Col>
          </>
        }
      </div>
    );
  }

  setUpMeeting = () => {
    return(
      <>
        <div className="col-12 col-xl-12 px-0 px-sm-4 pt-4 pb-2">
          <span className="title">{getMessage("MEETING_SETTINGS")}</span>
          <span className="px-2 message">{getMessage("MEETING_MESSAGE")}</span>
        </div>

        <div className="col-12 col-xl-12 flexDirectionColumn px-0 px-sm-4 pt-2" id="inviteeScrollView">
          <label className="labelStyle">
            <img src={icBar} className="mr-2"/>
            {getMessage("MEETING_TITLE")}
            <span className="requireBadge">
              {getMessage("REQUIRED_BADGE")}
            </span>
          </label>
          <InputGroup>
            <FormControl
              type="text"
              onChange={this.handleInputChange}
              value={this.state.sessionTitle}
              placeholder={getMessage("ENTER_SESSION_NAME")}
              aria-label="Enter name"
              aria-describedby="basic-addon2"
              className="formControlName border"
              maxLength={25}
              onKeyPress={this.enterPressed}
              autoFocus={isIE ? false : true}
            />
          </InputGroup>
          <div className="errors autoHeight">{getMessage(this.state.errorMessage)}</div>
        </div>
        { this.state.isUserInventMsgCustomizeEnable
          ? this.renderUserInviteCustomizeTab()
          : this.renderUserInviteDefault()
        }
      </>
    )
  }

  renderUserInviteDefault() {
    return (
      <>
        <div className={"col-12 col-xl-12 " + (this.state.isUserInventMsgCustomizeEnable ? "px-0": "px-4")}>
          <label className="labelStyle pt-2">
            <img src={icBar} className="mr-2"/>
            {getMessage("HOW_TO_CONTACT_CUSTOMERS")}
            <span className="px-2">{getMessage(this.state.PleaseChooseAnyGuidanceMethodMsg)}</span>
          </label>
        </div>
        <div className={"col-12 col-xl-12 flexDirectionColumn pb-2 "
          + (this.state.isUserInventMsgCustomizeEnable ? "px-0" : "px-4")} id="inviteeCustom">
          { this.renderInviteeSection()}
          <div className="errors autoHeight">{getMessage(this.state.maxSmsSendMessageError)}</div>
          <div className="d-flex justify-content-center">
            <Col sm={6} xl={6}>
              <button
                id="proceedBtn"
                className="startBtn btn shadow-none rounded-pill w-100 whiteOnClick py-2"
                onClick={() => {
                  this.state.isInviteForce = this.state.isCheckInvite ? true : false;
                  let proceedBtn = document.getElementById("proceedBtn");
                  proceedBtn.disabled=true;
                  this.sessionProceed.next(this.handleProceedSMS);
                }}
              >
                {getMessage("SEND_SMS_OR_EMAIL")}
              </button> 
            </Col>
          </div>
        </div>
      </>
    )
  }

  handleScheduleMeetingCustomize = (emailToAddresses, smsToNumber, customize) => {
    let invitees = emailToAddresses + ',' + smsToNumber;
    invitees = invitees.replace(/^,/, '');
    invitees = invitees.replace(/,$/, '');
    this.setState({
      invitees,
      userInventMsgCustomizeInfo: customize,
    });
    setTimeout(() => {
      this.state.isInviteForce = this.state.isCheckInvite ? true : false;
      let proceedBtn = document.getElementById("proceedBtn");
      proceedBtn.disabled=true;
      this.sessionProceed.next(this.handleProceedSMS);
    }, 100);
  }

  handleUserInviteCustomizeTabSelect = (index) => {
    // INVITE_MSG_DEFAULT_TAB selected
    if (index == 1) {
      this.setState({
        invitees: "",
      })
    };
  }

  renderUserInviteCustomizeTab() {
    return (
      <div className="mx-0 mx-sm-4">
        <Tabs
          onSelect={this.handleUserInviteCustomizeTabSelect}
          selectedIndex={this.state.selectedUserInventMsgCustomizeTadIndex}
        >
          <TabList>
            <Tab>{getMessage("INVITE_MSG_CUSTOMIZE_TAB")}</Tab>
            <Tab>{getMessage("INVITE_MSG_DEFAULT_TAB")}</Tab>
          </TabList>

          <TabPanel>
            <div className="col-12 col-xl-12 px-0">
              <UserInviteCustomize
                language={this.props.language}
                isSMSEnabled={this.props.isSMSEnabled}
                userInventMsgCustomize={this.props.userInventMsgCustomize}
                userProfileData={this.props.userProfileData}
                isCheckInvite={this.state.isCheckInvite}
                inviteeErrorCode={this.state.inviteeErrorCode}
                inviteeErrorMessage={this.state.inviteeErrorMessage}
                checkInviteeErrorMessage={this.state.checkInviteeErrorMessage}
                isInviteForce={this.state.isInviteForce}
                maxSmsSendMessageError={this.state.maxSmsSendMessageError}
                dataNotUpdatedErrorMessage={this.state.dataNotUpdatedErrorMessage}
                userName={this.props.userName}
                showCheckInvite={this.showCheckInvite}
                handleScheduleMeeting={this.handleScheduleMeetingCustomize}
                isSchedule={false}
              />
            </div>
          </TabPanel>
          <TabPanel>
            {this.renderUserInviteDefault()}
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  joinWithMeetingCode =()=> {
    return(
      <div>
        <div className="col-12 col-xl-12 px-4 pt-4">
          <span className="mb-3 title d-flex align-items-center justify-content-center">
            {getMessage("SPECIFIED_MEETING_CODE")}
          </span>
          <div id="lookitPasscode"></div>
          <div className="d-flex pt-3 text-center justify-content-center">
            {getMessage("CONFERENCE_CODE_MESSAGE")}
          </div>
          <div className='d-flex justify-content-center pt-4 pb-3'>
            <div className={'col-sm-10 col-md-4 col-lg-4 col-xl-4'} >
              <button
                id="proceedBtn"
                className='startBtn btn shadow-none rounded-pill whiteOnClick py-2 w-100'
                onClick={() => {
                  let proceedBtn = document.getElementById("proceedBtn");
                  proceedBtn.disabled=true;
                  this.sessionProceed.next(this.handleProceed);
                }}>
                {getMessage("PARTICIPATE_IN_THE_MEETING")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  showCheckInvite = () => {
    let checkInviteMessage = [];
    this.state.checkInviteList.forEach((participant, index) => {
      const email = participant.split('@');
      checkInviteMessage.push(<>{email[0] + "@"}<span className="checkInvite">{email[1]}</span></>);
      if (this.state.checkInviteList.length - 1 > index) {
        checkInviteMessage.push(<>{", "}</>);
      }
    })
    return (
      <>{checkInviteMessage}</>
    );
  }

  render() {
    return (
      <div className="startSession">
        {/*show spinner when update , schedule and proceed request initiated*/}
        {this.state.spinnerVisibility && <Spinner showSpinner={this.state.spinnerVisibility} />}

        {/*modal popup for the success and failure*/}
        <Modal show={this.state.showModal} className="scheduleSessionModal" centered>
          <div className="p-3">
            <div className="d-flex justify-content-center">
              <img src={this.state.modalIcon}/>
            </div>
            < div className = {
              this.state.modalType === MODAL_TYPE.SUCCESS ?
                "d-flex justify-content-center p-3 modalMessage" : 
                "d-flex justify-content-center p-3 failureModalMessage"
            }
            >{this.state.modalMessage}</div>
            <div className="d-flex justify-content-center p-3">
              <div className="col-md-5"><button className = {
                this.state.modalType === MODAL_TYPE.SUCCESS ?
                  "btn w-100 rounded-pill modalBtn whiteOnClick" : 
                  "btn w-100 rounded-pill modalBtnFailure whiteOnClick" }
              onClick={this.toggleModal}>{getMessage("OK")}</button></div>
            </div>
          </div>
        </Modal>

        <section>
          <div className="container-fluid">
            <div className="d-flex align-items-center pt-2 backBtn" >
              <img src={icBack} className="pr-2 cursorPointer" onClick={this.backYesHandle}/>
              <span className="cursorPointer" onClick={this.backYesHandle}>{getMessage("BACK_TO_MENU")}</span>
            </div>
            <div className="container">
              <div className="col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
                <div className="col-5 col-sm-3 p-0 d-flex flex-column">
                  <Row>
                    <Col md={12} className="text-center">
                      <img
                        src={icMeeting}
                        className="img-fluid session-img createSessionImage"
                        alt="Start Session"
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <Row>
                <Col md={12} className="text-center pb-4">
                  <span className="sessionMenuTitle">{getMessage("START_A_MEETING")}</span>
                </Col>
              </Row>
              <div className="d-flex justify-content-center">
                <div className="card-body col-12 col-xl-9 mb-4">
                  <div className="row hideElement">
                    {
                      this.props.isPasscodeEnabled ?
                        <div className={this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE ?
                          "col-6 text-center activeJoinType cursorPointer" :
                          "col-6 text-center joinType cursorPointer"}
                        onClick={()=>this.changeJoinType(MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE)}>
                          {getMessage("START_WITH_THE_SPECIFIC_CODE")}
                        </div> :
                        ""
                    }
                    <div className={this.state.joinType !== MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE ?
                      "col-6 text-center activeJoinType cursorPointer" :
                      "col-6 text-center joinType cursorPointer"}
                    onClick={()=>this.changeJoinType(MEETING_JOIN_TYPE.SET_UP_NEW_MEETING)}>
                      {getMessage(this.state.setUpNewMeeting)}
                    </div>
                  </div>
                  {
                    this.state.joinType === MEETING_JOIN_TYPE.JOIN_WITH_MEETING_CODE
                      ? this.joinWithMeetingCode() : this.setUpMeeting()
                  }
                </div>
              </div>
            </div>
          </div>
        </section>
       
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language,
    currentSessionInvitees: getCurrentSessionInvitees(state),
    isSMSEnabled: selectIsSMSEnabled(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      saveCurrentSessionInvitees: actionFactory.saveCurrentSessionInvitees,
      setLanguageAction
    },
    dispatch
  );
};

export default modalScrollBar(withErrorHandler(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StartSession)
));
